import * as React from 'react';
import * as Moment from 'moment-timezone';
import ActionButtonGroup from './ActionButtonGroup';

interface ISetDateButtonsProps {
  date: Date;
  tz: string;
  setDate: (newDate: Moment.Moment) => void;
}

export default class SetDateButtons extends React.Component<ISetDateButtonsProps> {

  constructor(props: ISetDateButtonsProps) {
    super(props);

    this.setNow = this.setNow.bind(this);
    this.setYearStart = this.setYearStart.bind(this);
    this.setYearEnd = this.setYearEnd.bind(this);
    this.setMonthStart = this.setMonthStart.bind(this);
    this.setMonthEnd = this.setMonthEnd.bind(this);
    this.setWeekStart = this.setWeekStart.bind(this);
    this.setWeekEnd = this.setWeekEnd.bind(this);
  }

  public render() {
    return (
      <>
        <button
          type="button"
          className="btn btn-primary mr-1 mt-1"
          onClick={this.setNow}
        >
          Now
        </button>
        <ActionButtonGroup
          title="Year"
          actions={[{
            title: "start",
            action: this.setYearStart
          },
          {
            title: "end",
            action: this.setYearEnd
          }
          ]}
        />
        <ActionButtonGroup
          title="Month"
          actions={[{
            title: "start",
            action: this.setMonthStart
          },
          {
            title: "end",
            action: this.setMonthEnd
          }
          ]}
        />
        <ActionButtonGroup
          title="Week"
          actions={[{
            title: "start",
            action: this.setWeekStart
          },
          {
            title: "end",
            action: this.setWeekEnd
          }
          ]}
        />
      </>
    )
  }

  public setNow(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment().tz(this.props.tz).second(0));
  }

  public setYearStart(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment(this.props.date).tz(this.props.tz).startOf('year'));
  }

  public setYearEnd(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment(this.props.date).tz(this.props.tz).endOf('year'));
  }

  public setMonthStart(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment(this.props.date).tz(this.props.tz).startOf('month'));
  }

  public setMonthEnd(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment(this.props.date).tz(this.props.tz).endOf('month'));
  }

  public setWeekStart(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment(this.props.date).tz(this.props.tz).startOf('week'));
  }

  public setWeekEnd(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.setDate(Moment(this.props.date).tz(this.props.tz).endOf('week'));
  }

}


// WEBPACK FOOTER //
// ./src/Calculator/SetDateButtons.tsx